import { render, staticRenderFns } from "./wbAgentPage.vue?vue&type=template&id=a7c81b1a"
import script from "./wbAgentPage.vue?vue&type=script&lang=js"
export * from "./wbAgentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports